import React, { useState } from 'react'
import { QuicksaveInput } from 'src/components/Global/Input/Input'
import { ModalButton } from 'src/components/Global/Button/Button'
import { ModalTitleText, LabelText } from 'src/components/Global/Text/TitleText'
import { NOCWrapper, FormContainer, Wrapper } from './style'
import { updateNextOfKinAction } from 'src/redux/actions/profileAction'
import { UpdateNextOfkinDto } from 'src/services/types'
import { phoneNumberRegEx } from 'src/Pages/Auth/Register/PhoneNumberReg'
import { Spinner } from 'src/components/Global/Spinner/Spinner'
import { RiErrorWarningLine } from 'react-icons/ri'
import { useTypedSelector } from 'src/redux/root-reducer'
import { useDispatch } from 'react-redux'
import Select from 'react-select'
import useSnackbar from 'src/hooks/useSnackBar'
const NextOfKinSettings = () => {
  const NextOfKin = useTypedSelector(
    (state) => state.profile.getNextOfKinSettingsSuccess.nextOfKin
  )
  const dispatch = useDispatch()
  // useEffect(() => {
  //   dispatch(getNextOfKinAction())
  // }, [])

  const allBanks = useTypedSelector((state) => state.banksResult.banks)
  const { banks } = allBanks

  let answer = NextOfKin ? NextOfKin : ''
  console.log(NextOfKin, 'NOK')
  const options = banks?.map((bank: any) => {
    return {
      value: bank.code,
      label: bank.name,
      id: bank.code,
    }
  })
  const [userData, setUserData] = useState<UpdateNextOfkinDto>({
    full_name: answer.full_name,
    email: answer.email,
    bank_name: answer.bank_name,
    account_number: answer.account_number,
    gender: answer.gender,
    phone_number: answer.phone_number,
    relationship: answer.relationship,
    address: answer.address,
  })
  const [profileSettingsLoading, setprofileSettingsLoading] = useState(false)
  const [alertMessage, setAlertMessage] = useState({
    type: '',
    message: '',
  })
  const {
    full_name,
    email,
    phone_number,
    bank_name,
    account_number,
    gender,
    relationship,
    address,
  } = userData
  const [submitted, setSubmitted] = useState(false)

  const handleChange = (e: any) => {
    const { name, value } = e.target
    const newData: any = { ...userData }
    newData[name] = value
    setUserData(newData)
  }

  const handleBank = (options: any) => {
    userData.bank_name = options.label
  }
  const handleGender = (options: any) => {
    userData.gender = options.label
    console.log(userData.gender)
  }
  const handleRelationship = (options: any) => {
    userData.relationship = options.value
    console.log(userData.relationship)
  }
  const handleSubmit = (e: any) => {
    e.preventDefault()
    const payload = {
      NextOfKinSettings: {
        ...userData,
      },
    }
    setprofileSettingsLoading(true)
    dispatch(updateNextOfKinAction({ payload, onSuccess, onError }))
  }

  const snackbar = useSnackbar()

  const onSuccess = (msg: any) => {
    setprofileSettingsLoading(false)
    snackbar.trigger({
      message: msg,
      severity: 'success',
    })
  }

  const onError = (error: any) => {
    setprofileSettingsLoading(false)
    snackbar.trigger({
      message: 'Error updating next of Kin data',
      severity: 'error',
    })
  }

  //react-select style
  const style = {
    control: (base: any) => ({
      ...base,
      // border: 0,
      // This line disable the blue border
      boxShadow: 'none',
      border: '1px solid #6e7191',
      height: '55px',
      borderRadius: '10px',
      marginBottom: '30px',
      color: '#2336FF',
    }),
  }
  const optionsGender = [
    { value: 'male', label: 'Male' },
    { value: 'female', label: 'Female' },
  ]
  const optionsRelationship = [
    { value: 'father', label: 'Father' },
    { value: 'mother', label: 'Mother' },
    { value: 'sister', label: 'Sister' },
    { value: 'brother', label: 'Brother' },
    { value: 'friend', label: 'Friend' },
    { value: 'husband', label: 'Husband' },
    { value: 'wife', label: 'Wife' },
  ]
  const Disabled = () => {
    if (
      !full_name ||
      !bank_name ||
      !account_number ||
      !gender ||
      !relationship ||
      !address ||
      full_name.length <= 2 ||
      address.length <= 2 ||
      !email ||
      phone_number.length !== 11 ||
      !phoneNumberRegEx.test(phone_number) ||
      account_number.length !== 10
    ) {
      return 'blur'
    }
    return null
  }
  return (
    <FormContainer>
      <Wrapper onSubmit={handleSubmit}>
        <NOCWrapper>
          <div>
            <ModalTitleText>Next of Kin Settings</ModalTitleText>
            <LabelText className="minus">
              Please input the details of your next of kin
            </LabelText>
            <div className="amount first">
              <LabelText>Full Name</LabelText>
              <div
                className={
                  'form-group' + (submitted && !full_name ? ' has-error' : '')
                }
              >
                <QuicksaveInput
                  className="height"
                  type="text"
                  name="full_name"
                  value={full_name}
                  onChange={handleChange}
                  placeholder=""
                />
                {(submitted && !full_name && (
                  <p className="error-text">Full Name is required</p>
                )) ||
                  (submitted && full_name.length <= 2 && (
                    <p className="error-text">full name is too short</p>
                  ))}
                <RiErrorWarningLine className="error-icon" />
              </div>
            </div>
            <div className="amount">
              <LabelText>Email address</LabelText>
              <div
                className={
                  'form-group' + (submitted && !email ? ' has-error' : '')
                }
              >
                <QuicksaveInput
                  className="height"
                  type="email"
                  placeholder=""
                  name="email"
                  value={email}
                  onChange={handleChange}
                />
                {submitted && !email && (
                  <p className="error-text">Email is required</p>
                )}
                <RiErrorWarningLine className="error-icon" />
              </div>
            </div>
            <div className="amount">
              <LabelText>Phone</LabelText>
              <div
                className={
                  'form-group' +
                  (submitted && !phone_number ? ' has-error' : '')
                }
              >
                <QuicksaveInput
                  className="height"
                  type="text"
                  placeholder=""
                  name="phone_number"
                  value={phone_number}
                  onChange={handleChange}
                />

                {(submitted && !phone_number && (
                  <p className="error-text">Phone Number is required</p>
                )) ||
                  (submitted && !phoneNumberRegEx.test(phone_number) && (
                    <p className="error-text">Not a valid Nigerian Number</p>
                  ))}

                <RiErrorWarningLine className="error-icon" />
              </div>
            </div>
            <div className="new-top">
              <span>Bank Details</span>
              <div className="form-group-select">
                <LabelText>Bank Name</LabelText>
                <Select
                  name={options.label}
                  value={options.bank_code}
                  placeholder={bank_name ? bank_name : 'select Bank'}
                  options={options}
                  onChange={handleBank}
                  className="bank_code_select select_input"
                  styles={style}
                />
              </div>
              <div className="amount">
                <LabelText>Account number</LabelText>
                <div
                  className={
                    'form-group' +
                    (submitted && !account_number ? ' has-error' : '')
                  }
                >
                  <QuicksaveInput
                    className="height"
                    type="text"
                    placeholder=""
                    name="account_number"
                    value={account_number}
                    onChange={handleChange}
                  />

                  {(submitted && !account_number && (
                    <p className="error-text">Account number is required</p>
                  )) ||
                    (submitted && account_number.length !== 10 && (
                      <p className="error-text">Not a valid Account Number</p>
                    ))}
                  <RiErrorWarningLine className="error-icon" />
                </div>
              </div>
            </div>
            <div className="new-top">
              <span>Other Details</span>
              <div className="form-group-select">
                <LabelText>Relationship</LabelText>
                <Select
                  placeholder={
                    relationship ? relationship : 'select Relationship'
                  }
                  options={optionsRelationship}
                  onChange={handleRelationship}
                  className="filter_select select_input"
                  styles={style}
                />
              </div>
              <div className="form-group-select">
                <LabelText>Gender</LabelText>
                <Select
                  placeholder={gender ? gender : 'select Gender'}
                  options={optionsGender}
                  onChange={handleGender}
                  className="filter_select"
                  styles={style}
                />
              </div>
              <div className="amount">
                <LabelText>Address</LabelText>
                <div
                  className={
                    'form-group' + (submitted && !address ? ' has-error' : '')
                  }
                >
                  <QuicksaveInput
                    className="height"
                    type="text"
                    name="address"
                    value={address}
                    onChange={handleChange}
                    placeholder=""
                  />
                  {(submitted && !address && (
                    <p className="error-text">Address is required</p>
                  )) ||
                    (submitted && address.length <= 2 && (
                      <p className="error-text">Address is too short</p>
                    ))}
                  <RiErrorWarningLine className="error-icon" />
                </div>
              </div>
            </div>
          </div>
        </NOCWrapper>
        <div className="tops">
          <ModalButton onClick={handleSubmit}>
            Update Next Of Kin
            {profileSettingsLoading && <Spinner />}
          </ModalButton>
        </div>
      </Wrapper>
    </FormContainer>
  )
}

export { NextOfKinSettings }
